<!-- ═══════════════ FEATURE CARDS (SWAP, LIQUIDITY, FARMS, STAKING) ═══════════════ -->
<section class="max-w-[1320px] mx-auto px-6 lg:px-10 py-12 lg:py-12">
  <h3
    class="font-display font-black text-2xl text-white uppercase tracking-wider text-center mb-10 lg:mb-12 flex flex-col items-center gap-4">
    Ecosystem Hub
    <span class="w-16 h-1 bg-gold rounded-full shadow-[0_0_10px_rgba(245,183,59,0.5)]"></span>
  </h3>
  <div class="grid grid-cols-1 tablet:grid-cols-2 desktop:grid-cols-4 gap-5">
    @for (item of state.homeCms().ecosystem; track item.title; let i = $index) {
    <div (click)="state.openEcosystemCard(i)" class="card card-interactive p-6 flex flex-col gap-4.5 cursor-pointer">
      <div class="feature-icon">
        @switch (i) {
        @case (0) {
        <svg class="w-5.5 h-5.5" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M7.5 21 3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5" />
        </svg>
        }
        @case (1) {
        <svg class="w-5.5 h-5.5" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M12 3c-1.2 0-4.8 5.4-4.8 9.6a4.8 4.8 0 0 0 9.6 0C16.8 8.4 13.2 3 12 3Z" />
        </svg>
        }
        @case (2) {
        <svg class="w-5.5 h-5.5" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M12 21v-8.25M15.75 21v-8.25M8.25 21v-8.25M3 9l9-6 9 6m-1.5 12V10.332A48.36 48.36 0 0 0 12 9.75c-2.551 0-5.056.2-7.5.582V21" />
        </svg>
        }
        @default {
        <svg class="w-5.5 h-5.5" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z" />
        </svg>
        }
        }
      </div>
      <div>
        <h3 class="font-display font-bold text-white text-[18px] tracking-wide">{{ item.title }}</h3>
        <p class="text-[#999999] text-[14px] mt-2 leading-relaxed font-normal">{{ item.description }}</p>
      </div>
    </div>
    }
  </div>
</section>

<!-- ═══════════════ BLOCKCHAIN NETWORKS TVL CARDS ═══════════════ -->
<section class="max-w-[1320px] mx-auto px-6 lg:px-10 pb-12 lg:pb-16">
  <h3
    class="font-display font-black text-2xl text-white uppercase tracking-wider text-center mb-10 lg:mb-12 flex flex-col items-center gap-4">
    Supported Networks
    <span class="w-16 h-1 bg-gold rounded-full shadow-[0_0_10px_rgba(245,183,59,0.5)]"></span>
  </h3>
  <div class="grid grid-cols-1 md:grid-cols-3 gap-6">

    <!-- BNB Chain Premium Card -->
    <div
      class="card card-interactive p-5 sm:p-6 lg:p-6.5 relative overflow-hidden group flex flex-col justify-between h-full">
      <div
        class="absolute -right-16 -top-16 w-32 h-32 bg-yellow-500/[0.04] rounded-full blur-2xl group-hover:bg-yellow-500/[0.08] transition-all">
      </div>

      <div class="flex items-center justify-between mb-5 gap-2 min-h-[52px]">
        <div class="flex items-center gap-3 min-w-0">
          <div class="network-icon flex-shrink-0">
            <svg class="w-9.5 h-9.5" viewBox="0 0 32 32" fill="none">
              <path d="M16 4l3.2 3.2-6.4 6.4L16 16.8l6.4-6.4 3.2 3.2L16 23.2l-9.6-9.6L16 4z" fill="#F5B73B" />
              <path d="M8.8 16l-3.2 3.2L16 29.6l10.4-10.4L23.2 16 16 23.2 8.8 16z" fill="#F5B73B" opacity=".5" />
            </svg>
          </div>
          <div class="min-w-0">
            <h4
              class="font-display font-extrabold text-base md:text-[13.5px] lg:text-[15.5px] xl:text-lg text-white uppercase tracking-wide lg:tracking-wider truncate">
              BNB Smart Chain</h4>
            <p class="text-[10px] text-yellow-500 font-bold uppercase tracking-widest mt-0.5 truncate">High
              Performance</p>
          </div>
        </div>
        <span
          class="text-xs md:text-[10.5px] lg:text-xs bg-yellow-500/10 text-yellow-400 font-bold px-2.5 py-1 md:px-2 md:py-0.5 lg:px-2.5 lg:py-1 rounded-lg border border-yellow-500/20 whitespace-nowrap flex-shrink-0">55%
          Share</span>
      </div>

      <div class="grid grid-cols-2 gap-4 lg:gap-6 mb-4">
        <div class="min-w-0">
          <p class="text-text-dim text-[10px] uppercase tracking-wider font-extrabold truncate">Liquidity Pools TVL
          </p>
          <p
            class="font-display font-black text-2xl md:text-lg lg:text-[22px] xl:text-2xl text-white mt-1.5 whitespace-nowrap">
            {{ bnbStats.tvl }}</p>
        </div>
        <div class="min-w-0">
          <p class="text-text-dim text-[10px] uppercase tracking-wider font-extrabold truncate">Volume (24H)</p>
          <p
            class="font-display font-black text-2xl md:text-lg lg:text-[22px] xl:text-2xl text-white mt-1.5 whitespace-nowrap">
            {{ bnbStats.vol }}</p>
        </div>
      </div>

      <div class="custom-progress mt-2">
        <div class="custom-progress-bar" style="width: 55%"></div>
      </div>
    </div>

    <!-- Ethereum Premium Card -->
    <div id="ethereum-network"
      class="card card-interactive p-5 sm:p-6 lg:p-6.5 relative overflow-hidden group flex flex-col justify-between h-full">
      <div
        class="absolute -right-16 -top-16 w-32 h-32 bg-blue-500/[0.04] rounded-full blur-2xl group-hover:bg-blue-500/[0.08] transition-all">
      </div>

      <div class="flex items-center justify-between mb-5 gap-2 min-h-[52px]">
        <div class="flex items-center gap-3 min-w-0">
          <div class="network-icon flex-shrink-0">
            <svg class="w-9.5 h-9.5" viewBox="0 0 32 32" fill="none">
              <path d="M16 4l8 12.8L16 20 8 16.8 16 4z" fill="#627eea" />
              <path d="M16 22l8-5.2L16 28 8 16.8 16 22z" fill="#627eea" opacity=".5" />
            </svg>
          </div>
          <div class="min-w-0">
            <h4
              class="font-display font-extrabold text-base md:text-[13.5px] lg:text-[15.5px] xl:text-lg text-white uppercase tracking-wide lg:tracking-wider truncate">
              Ethereum Network</h4>
            <p class="text-[10px] text-blue-400 font-bold uppercase tracking-widest mt-0.5 truncate">Ultra Secure</p>
          </div>
        </div>
        <span
          class="text-xs md:text-[10.5px] lg:text-xs bg-blue-500/10 text-blue-400 font-bold px-2.5 py-1 md:px-2 md:py-0.5 lg:px-2.5 lg:py-1 rounded-lg border border-blue-500/20 whitespace-nowrap flex-shrink-0">30%
          Share</span>
      </div>

      <div class="grid grid-cols-2 gap-4 lg:gap-6 mb-4">
        <div class="min-w-0">
          <p class="text-text-dim text-[10px] uppercase tracking-wider font-extrabold truncate">Liquidity Pools TVL
          </p>
          <p
            class="font-display font-black text-2xl md:text-lg lg:text-[22px] xl:text-2xl text-white mt-1.5 whitespace-nowrap">
            {{ ethStats.tvl }}</p>
        </div>
        <div class="min-w-0">
          <p class="text-text-dim text-[10px] uppercase tracking-wider font-extrabold truncate">Volume (24H)</p>
          <p
            class="font-display font-black text-2xl md:text-lg lg:text-[22px] xl:text-2xl text-white mt-1.5 whitespace-nowrap">
            {{ ethStats.vol }}</p>
        </div>
      </div>

      <div class="custom-progress mt-2">
        <div class="custom-progress-bar"
          style="width: 30%; background: linear-gradient(90deg, #5163ba, #7e94fc); box-shadow: 0 0 10px rgba(98, 126, 234, 0.4);">
        </div>
      </div>
    </div>

    <!-- Polygon Premium Card -->
    <div id="polygon-network"
      class="card card-interactive p-5 sm:p-6 lg:p-6.5 relative overflow-hidden group flex flex-col justify-between h-full">
      <div
        class="absolute -right-16 -top-16 w-32 h-32 bg-purple-500/[0.04] rounded-full blur-2xl group-hover:bg-purple-500/[0.08] transition-all">
      </div>

      <div class="flex items-center justify-between mb-5 gap-2 min-h-[52px]">
        <div class="flex items-center gap-3 min-w-0">
          <div class="network-icon flex-shrink-0">
            <svg class="w-9.5 h-9.5" viewBox="0 0 32 32" fill="none">
              <path d="M21.5 8h-11L5 17.5l5.5 9.5h11L27 17.5 21.5 8z" fill="#8247E5" />
            </svg>
          </div>
          <div class="min-w-0">
            <h4
              class="font-display font-extrabold text-base md:text-[13.5px] lg:text-[15.5px] xl:text-lg text-white uppercase tracking-wide lg:tracking-wider truncate">
              Polygon Network</h4>
            <p class="text-[10px] text-purple-400 font-bold uppercase tracking-widest mt-0.5 truncate">Ultra Low Fees
            </p>
          </div>
        </div>
        <span
          class="text-xs md:text-[10.5px] lg:text-xs bg-purple-500/10 text-purple-400 font-bold px-2.5 py-1 md:px-2 md:py-0.5 lg:px-2.5 lg:py-1 rounded-lg border border-purple-500/20 whitespace-nowrap flex-shrink-0">15%
          Share</span>
      </div>

      <div class="grid grid-cols-2 gap-4 lg:gap-6 mb-4">
        <div class="min-w-0">
          <p class="text-text-dim text-[10px] uppercase tracking-wider font-extrabold truncate">Liquidity Pools TVL
          </p>
          <p
            class="font-display font-black text-2xl md:text-lg lg:text-[22px] xl:text-2xl text-white mt-1.5 whitespace-nowrap">
            {{ polygonStats.tvl }}</p>
        </div>
        <div class="min-w-0">
          <p class="text-text-dim text-[10px] uppercase tracking-wider font-extrabold truncate">Volume (24H)</p>
          <p
            class="font-display font-black text-2xl md:text-lg lg:text-[22px] xl:text-2xl text-white mt-1.5 whitespace-nowrap">
            {{ polygonStats.vol }}</p>
        </div>
      </div>

      <div class="custom-progress mt-2">
        <div class="custom-progress-bar"
          style="width: 15%; background: linear-gradient(90deg, #8247E5, #a367fb); box-shadow: 0 0 10px rgba(130, 71, 229, 0.4);">
        </div>
      </div>
    </div>

  </div>
</section>

<!-- ═══════════════ PLATFORM STATISTICS SECTION ═══════════════ -->
<section class="max-w-[1320px] mx-auto px-6 lg:px-10 pb-16 pt-8 relative z-10">

  <h3
    class="font-display font-black text-2xl text-white uppercase tracking-wider text-center mb-10 flex flex-col items-center gap-4">
    Platform Statistics
    <span class="w-16 h-1 bg-gold rounded-full shadow-[0_0_10px_rgba(245,183,59,0.5)]"></span>
  </h3>

  <div class="grid grid-cols-1 tablet:grid-cols-2 desktop:grid-cols-4 gap-6 items-center justify-center">

    <div
      class="card p-6 md:p-8 rounded-[20px] bg-[#0c0c0c]/80 border border-gold/20 shadow-[0_8px_30px_rgba(0,0,0,0.5)] flex items-center gap-4 group hover:-translate-y-1 transition-all duration-300">
      <div
        class="w-12 h-12 rounded-full border border-gold/30 bg-gold/5 flex items-center justify-center text-gold shadow-[0_0_15px_rgba(245,183,59,0.15)] shrink-0">
        <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z" />
        </svg>
      </div>
      <div class="flex flex-col text-left">
        <h3
          class="font-display font-bold text-[28px] xl:text-[32px] text-white tracking-tight leading-none group-hover:text-gold transition-colors">
          {{ platformStats.tvl }}</h3>
        <p class="text-[#999999] text-[13.5px] mt-1.5 font-medium">Total Value Locked</p>
      </div>
    </div>

    <div
      class="card p-6 md:p-8 rounded-[20px] bg-[#0c0c0c]/80 border border-gold/20 shadow-[0_8px_30px_rgba(0,0,0,0.5)] flex items-center gap-4 group hover:-translate-y-1 transition-all duration-300">
      <div
        class="w-12 h-12 rounded-full border border-gold/30 bg-gold/5 flex items-center justify-center text-gold shadow-[0_0_15px_rgba(245,183,59,0.15)] shrink-0">
        <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z" />
        </svg>
      </div>
      <div class="flex flex-col text-left">
        <h3
          class="font-display font-bold text-[28px] xl:text-[32px] text-white tracking-tight leading-none group-hover:text-gold transition-colors">
          {{ platformStats.users }}</h3>
        <p class="text-[#999999] text-[13.5px] mt-1.5 font-medium">Total Users</p>
      </div>
    </div>

    <div
      class="card p-6 md:p-8 rounded-[20px] bg-[#0c0c0c]/80 border border-gold/20 shadow-[0_8px_30px_rgba(0,0,0,0.5)] flex items-center gap-4 group hover:-translate-y-1 transition-all duration-300">
      <div
        class="w-12 h-12 rounded-full border border-gold/30 bg-gold/5 flex items-center justify-center text-gold shadow-[0_0_15px_rgba(245,183,59,0.15)] shrink-0">
        <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M7.5 21 3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5" />
        </svg>
      </div>
      <div class="flex flex-col text-left">
        <h3
          class="font-display font-bold text-[28px] xl:text-[32px] text-white tracking-tight leading-none group-hover:text-gold transition-colors">
          {{ platformStats.pools }}</h3>
        <p class="text-[#999999] text-[13.5px] mt-1.5 font-medium">Active Pools</p>
      </div>
    </div>

    <div
      class="card p-6 md:p-8 rounded-[20px] bg-[#0c0c0c]/80 border border-gold/20 shadow-[0_8px_30px_rgba(0,0,0,0.5)] flex items-center gap-4 group hover:-translate-y-1 transition-all duration-300">
      <div
        class="w-12 h-12 rounded-full border border-gold/30 bg-gold/5 flex items-center justify-center text-gold shadow-[0_0_15px_rgba(245,183,59,0.15)] shrink-0">
        <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 0 1 3 19.875v-6.75ZM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V8.625ZM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V4.125Z" />
        </svg>
      </div>
      <div class="flex flex-col text-left">
        <h3
          class="font-display font-bold text-[28px] xl:text-[32px] text-white tracking-tight leading-none group-hover:text-gold transition-colors">
          {{ platformStats.vol }}</h3>
        <p class="text-[#999999] text-[13.5px] mt-1.5 font-medium">Total Volume (24H)</p>
      </div>
    </div>

  </div>
</section>